
import React from "react";

const Reservations = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Reservations</h1>
      <p className="text-muted-foreground">Manage your restaurant reservations here.</p>
    </div>
  );
};

export default Reservations;
